/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Dpi_Nodistributions2Inputs */

const en_coinvestments_report_dpi_nodistributions2 = /** @type {(inputs: Coinvestments_Report_Dpi_Nodistributions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No distributions`)
};

/**
* | output |
* | --- |
* | "No distributions" |
*
* @param {Coinvestments_Report_Dpi_Nodistributions2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_dpi_nodistributions2 = /** @type {((inputs?: Coinvestments_Report_Dpi_Nodistributions2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Dpi_Nodistributions2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_dpi_nodistributions2(inputs)
});
export { coinvestments_report_dpi_nodistributions2 as "coInvestments_report_dpi_noDistributions" }